<template>
  <div class="drugInfo">
    <img v-if="!_isMobile" src="https://cdn.youjiajk.com/appfile/drugBanner.png" width="100%" />
    <img v-else src="https://cdn.youjiajk.com/appfile/drugBanner_m.png" width="100%" />
    <div :class="!_isMobile ? 'wrapperPc container' : 'wrapperMobile'">
      <div class="title">药品信息</div>
      <div class="productItem" v-for="(item,index) in dataList" :key="index" @click="goDetail(index)">
        <img :src="item.imgUrl" />
        <p>{{item.name}}</p>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        _isMobile: false,
        dataList: [{
            imgUrl: 'https://cdn.youjiajk.com/appfile/drug1.png',
            name: '多维元素胶囊(13)'
          },
          {
            imgUrl: 'https://cdn.youjiajk.com/appfile/drug2.png',
            name: '复方薄荷脑软膏'
          },
          {
            imgUrl: 'https://cdn.youjiajk.com/appfile/drug3.png',
            name: '复方消化酶胶囊'
          },
          {
            imgUrl: 'https://cdn.youjiajk.com/appfile/drug4.png',
            name: '聚乙烯醇滴眼液'
          },
          {
            imgUrl: 'https://cdn.youjiajk.com/appfile/drug5.png',
            name: '六味地黄丸'
          },
          {
            imgUrl: 'https://cdn.youjiajk.com/appfile/drug6.png',
            name: '维D钙咀嚼片'
          },
          {
            imgUrl: 'https://cdn.youjiajk.com/appfile/drug7.png',
            name: '盐酸特比萘芬乳膏'
          },
          {
            imgUrl: 'https://cdn.youjiajk.com/appfile/drug8.png',
            name: '叶酸片'
          }
        ],
        drugInfo: [{

        }]
      }
    },
    created() {
      this._isMobile = this.$util._isMobile()
    },
    methods: {
      goDetail(index) {
        this.$router.push({
          name: 'drugDetail',
          query: {
            id: index
          }
        })
      }
    }
  }
</script>

<style scoped lang="less">
  .drugInfo {
    font-size: 16px;
    color: #333;
    line-height: 22px;

    .wrapperPc {
      display: flex;
      flex-wrap: wrap;
      margin: 36px auto 60px auto;
      width: 1221px;

      .title {
        width: 1183px;
        background: #F4F4F8;
        height: 58px;
        font-size: 20px;
        color: #333;
        padding-left: 24px;
        line-height: 58px;
        font-weight: 600;
        margin-bottom: 30px;
      }

      .productItem {
        border: 1px solid #DADADA;
        margin-bottom: 16px;
        margin-right: 13px;
        padding-bottom: 16px;
        // margin-top: 30px;
      }

      img {
        width: 290px;
        height: 235px;
        margin-bottom: 16px;
      }

      p {
        margin-left: 24px;
      }
    }

    .wrapperMobile {
      display: flex;
      flex-wrap: wrap;
      font-size: 0.13rem;
      padding-bottom: 0.8rem;
      

      .title {
        width: 100%;
        height: 0.7rem;
        background: #F4F4F8;
        font-size: 0.3rem;
        line-height: 0.7rem;
        color: #333;
        padding-left: .4rem;
        margin-top: 0.2rem;
        margin: 0.2rem 0.2rem 0.3rem;
        font-weight: 600;
      }

      .productItem {
        width: 29%;
        border: 1px solid #DADADA;
        margin-bottom: 0.2rem;
        margin-left: 0.2rem;
        text-align: center;
        display: flex;
        flex-direction: column;

        img {
          width: 2rem;
          height: 1.88rem;
        }

        p {
          text-align: center;

          line-height: 0.3rem;
          font-size: 0.16rem;
        }
      }
    }

    .productItem {}
  }
</style>


// WEBPACK FOOTER //
// src/views/drug.vue